// Health timeline proxy for the Sunstone platform.
//
// Provides time-bucketed health blips from the sunstone-status service
// for any entity in the hierarchy: partner, tenant, deployment, or workspace.
//
// Authentication: valid JWT required (requiresAuth: true).
//
// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file health/v1/health.proto (package health.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file health/v1/health.proto.
 */
export const file_health_v1_health: GenFile = /*@__PURE__*/
  fileDesc("ChZoZWFsdGgvdjEvaGVhbHRoLnByb3RvEgloZWFsdGgudjEiJgoEQmxpcBIOCgZidWNrZXQYASABKAkSDgoGc3RhdHVzGAIgASgJIl4KDkhlYWx0aFN1YnRvdGFsEg0KBWxldmVsGAEgASgJEgoKAmlkGAIgASgJEhEKCXBhcmVudF9pZBgDIAEoCRIeCgVibGlwcxgEIAMoCzIPLmhlYWx0aC52MS5CbGlwInQKGEdldEhlYWx0aFRpbWVsaW5lUmVxdWVzdBIKCgJpZBgBIAEoCRINCgVsZXZlbBgCIAEoCRIMCgRmcm9tGAMgASgJEgoKAnRvGAQgASgJEg0KBWdyYWluGAUgASgJEhQKDG92ZXJhbGxfb25seRgGIAEoCCKGAQoZR2V0SGVhbHRoVGltZWxpbmVSZXNwb25zZRIKCgJpZBgBIAEoCRINCgVsZXZlbBgCIAEoCRIgCgdvdmVyYWxsGAMgAygLMg8uaGVhbHRoLnYxLkJsaXASLAoJc3VidG90YWxzGAQgAygLMhkuaGVhbHRoLnYxLkhlYWx0aFN1YnRvdGFsIjUKHUdldFNlcnZpY2VIZWFsdGhTdGF0dXNSZXF1ZXN0EhQKDHdvcmtzcGFjZV9pZBgBIAEoCSKAAQoSU2VydmljZUNoZWNrU3RhdHVzEgwKBG5hbWUYASABKAkSDgoGc3RhdHVzGAIgASgJEhAKCGNoZWNrX2lkGAMgASgJEhQKDGxhc3RfY2hlY2tlZBgEIAEoCRIVCg1lcnJvcl9tZXNzYWdlGAUgASgJEg0KBW93bmVyGAYgASgJIk8KHkdldFNlcnZpY2VIZWFsdGhTdGF0dXNSZXNwb25zZRItCgZjaGVja3MYASADKAsyHS5oZWFsdGgudjEuU2VydmljZUNoZWNrU3RhdHVzIi0KGUludmVzdGlnYXRlU2VydmljZVJlcXVlc3QSEAoId29ya2xvYWQYASABKAkiMAoaSW52ZXN0aWdhdGVTZXJ2aWNlUmVzcG9uc2USEgoKcm9vdF9jYXVzZRgBIAEoCTLQAgoNSGVhbHRoU2VydmljZRJjChFHZXRIZWFsdGhUaW1lbGluZRIjLmhlYWx0aC52MS5HZXRIZWFsdGhUaW1lbGluZVJlcXVlc3QaJC5oZWFsdGgudjEuR2V0SGVhbHRoVGltZWxpbmVSZXNwb25zZSIDkAIBEnIKFkdldFNlcnZpY2VIZWFsdGhTdGF0dXMSKC5oZWFsdGgudjEuR2V0U2VydmljZUhlYWx0aFN0YXR1c1JlcXVlc3QaKS5oZWFsdGgudjEuR2V0U2VydmljZUhlYWx0aFN0YXR1c1Jlc3BvbnNlIgOQAgESZgoSSW52ZXN0aWdhdGVTZXJ2aWNlEiQuaGVhbHRoLnYxLkludmVzdGlnYXRlU2VydmljZVJlcXVlc3QaJS5oZWFsdGgudjEuSW52ZXN0aWdhdGVTZXJ2aWNlUmVzcG9uc2UiA5ACAUI/Wj1naXRodWIuY29tL3VuaXBob3JlL3N1bnN0b25lL3BrZy9nby9nZW4vcGIvaGVhbHRoL3YxO2hlYWx0aFYxYgZwcm90bzM");

/**
 * Blip represents a single time-bucketed health data point.
 *
 * @generated from message health.v1.Blip
 */
export type Blip = Message<"health.v1.Blip"> & {
  /**
   * RFC3339 timestamp for the start of this time bucket.
   *
   * @generated from field: string bucket = 1;
   */
  bucket: string;

  /**
   * Health status: "green", "yellow", or "red".
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message health.v1.Blip.
 * Use `create(BlipSchema)` to create a new message.
 */
export const BlipSchema: GenMessage<Blip> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 0);

/**
 * HealthSubtotal holds blips for a single child entity in the hierarchy.
 *
 * @generated from message health.v1.HealthSubtotal
 */
export type HealthSubtotal = Message<"health.v1.HealthSubtotal"> & {
  /**
   * Level of this entity: sunstone_partner, sunstone_tenant, sunstone_deployment, sunstone_workspace.
   *
   * @generated from field: string level = 1;
   */
  level: string;

  /**
   * Sunstone-status ID of this entity.
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Sunstone-status ID of the parent entity.
   *
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: repeated health.v1.Blip blips = 4;
   */
  blips: Blip[];
};

/**
 * Describes the message health.v1.HealthSubtotal.
 * Use `create(HealthSubtotalSchema)` to create a new message.
 */
export const HealthSubtotalSchema: GenMessage<HealthSubtotal> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 1);

/**
 * GetHealthTimelineRequest proxies to the sunstone-status blips/selected GET API.
 *
 * @generated from message health.v1.GetHealthTimelineRequest
 */
export type GetHealthTimelineRequest = Message<"health.v1.GetHealthTimelineRequest"> & {
  /**
   * Sunstone-status entity ID (e.g. "partner-7f4299f744b1", "deployment-28bdb3c436cb").
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Hierarchy level: sunstone_partner | sunstone_tenant | sunstone_deployment | sunstone_workspace.
   *
   * @generated from field: string level = 2;
   */
  level: string;

  /**
   * RFC3339 start of the time range.
   *
   * @generated from field: string from = 3;
   */
  from: string;

  /**
   * RFC3339 end of the time range.
   *
   * @generated from field: string to = 4;
   */
  to: string;

  /**
   * Time bucket size: "minute", "hour", or "day".
   *
   * @generated from field: string grain = 5;
   */
  grain: string;

  /**
   * If true, return only the overall rollup without subtotals.
   *
   * @generated from field: bool overall_only = 6;
   */
  overallOnly: boolean;
};

/**
 * Describes the message health.v1.GetHealthTimelineRequest.
 * Use `create(GetHealthTimelineRequestSchema)` to create a new message.
 */
export const GetHealthTimelineRequestSchema: GenMessage<GetHealthTimelineRequest> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 2);

/**
 * GetHealthTimelineResponse mirrors the sunstone-status blips/selected response.
 *
 * @generated from message health.v1.GetHealthTimelineResponse
 */
export type GetHealthTimelineResponse = Message<"health.v1.GetHealthTimelineResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string level = 2;
   */
  level: string;

  /**
   * Rollup blips for the requested entity (across all its children).
   *
   * @generated from field: repeated health.v1.Blip overall = 3;
   */
  overall: Blip[];

  /**
   * Per-child blips for each entity in the hierarchy below the requested level.
   *
   * @generated from field: repeated health.v1.HealthSubtotal subtotals = 4;
   */
  subtotals: HealthSubtotal[];
};

/**
 * Describes the message health.v1.GetHealthTimelineResponse.
 * Use `create(GetHealthTimelineResponseSchema)` to create a new message.
 */
export const GetHealthTimelineResponseSchema: GenMessage<GetHealthTimelineResponse> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 3);

/**
 * GetServiceHealthStatusRequest requests per-service health for a workspace.
 *
 * @generated from message health.v1.GetServiceHealthStatusRequest
 */
export type GetServiceHealthStatusRequest = Message<"health.v1.GetServiceHealthStatusRequest"> & {
  /**
   * Workspace ID (workspace_xxx format) to fetch service health for.
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message health.v1.GetServiceHealthStatusRequest.
 * Use `create(GetServiceHealthStatusRequestSchema)` to create a new message.
 */
export const GetServiceHealthStatusRequestSchema: GenMessage<GetServiceHealthStatusRequest> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 4);

/**
 * ServiceCheckStatus represents the latest health result for one service check.
 *
 * @generated from message health.v1.ServiceCheckStatus
 */
export type ServiceCheckStatus = Message<"health.v1.ServiceCheckStatus"> & {
  /**
   * Human-readable check/service name.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Health status: "green", "yellow", "red", "timeout", "error", "suppressed".
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * Check definition ID (e.g. "CD_000022").
   *
   * @generated from field: string check_id = 3;
   */
  checkId: string;

  /**
   * RFC3339 timestamp of the last check execution.
   *
   * @generated from field: string last_checked = 4;
   */
  lastChecked: string;

  /**
   * Reason the check is not green: the failing criteria (field, operator,
   * actual vs. expected, semicolon-joined) or the raw executor error when
   * the check couldn't run at all. Empty when status is "green".
   *
   * @generated from field: string error_message = 5;
   */
  errorMessage: string;

  /**
   * Primary owner name from the Backstage catalog, matched by service name.
   * Empty if the service has no corresponding catalog entry or owner annotation.
   *
   * @generated from field: string owner = 6;
   */
  owner: string;
};

/**
 * Describes the message health.v1.ServiceCheckStatus.
 * Use `create(ServiceCheckStatusSchema)` to create a new message.
 */
export const ServiceCheckStatusSchema: GenMessage<ServiceCheckStatus> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 5);

/**
 * GetServiceHealthStatusResponse returns the list of service check statuses.
 *
 * @generated from message health.v1.GetServiceHealthStatusResponse
 */
export type GetServiceHealthStatusResponse = Message<"health.v1.GetServiceHealthStatusResponse"> & {
  /**
   * @generated from field: repeated health.v1.ServiceCheckStatus checks = 1;
   */
  checks: ServiceCheckStatus[];
};

/**
 * Describes the message health.v1.GetServiceHealthStatusResponse.
 * Use `create(GetServiceHealthStatusResponseSchema)` to create a new message.
 */
export const GetServiceHealthStatusResponseSchema: GenMessage<GetServiceHealthStatusResponse> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 6);

/**
 * InvestigateServiceRequest requests a live diagnostic run against a workload.
 *
 * @generated from message health.v1.InvestigateServiceRequest
 */
export type InvestigateServiceRequest = Message<"health.v1.InvestigateServiceRequest"> & {
  /**
   * Deployment/StatefulSet/DaemonSet/ReplicaSet/Job/CronJob name to investigate.
   *
   * @generated from field: string workload = 1;
   */
  workload: string;
};

/**
 * Describes the message health.v1.InvestigateServiceRequest.
 * Use `create(InvestigateServiceRequestSchema)` to create a new message.
 */
export const InvestigateServiceRequestSchema: GenMessage<InvestigateServiceRequest> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 7);

/**
 * InvestigateServiceResponse returns the investigation's root-cause finding.
 *
 * @generated from message health.v1.InvestigateServiceResponse
 */
export type InvestigateServiceResponse = Message<"health.v1.InvestigateServiceResponse"> & {
  /**
   * Root cause of the workload's unhealthy state, as determined by the
   * investigate-controller. Empty if the investigation could not run.
   *
   * @generated from field: string root_cause = 1;
   */
  rootCause: string;
};

/**
 * Describes the message health.v1.InvestigateServiceResponse.
 * Use `create(InvestigateServiceResponseSchema)` to create a new message.
 */
export const InvestigateServiceResponseSchema: GenMessage<InvestigateServiceResponse> = /*@__PURE__*/
  messageDesc(file_health_v1_health, 8);

/**
 * HealthService provides health timeline data from the sunstone-status service
 * for any entity level in the deployment hierarchy.
 *
 * @generated from service health.v1.HealthService
 */
export const HealthService: GenService<{
  /**
   * GetHealthTimeline returns time-bucketed health blips for an entity and its
   * children. Proxies to sunstone-status with an M2M Auth0 token fetched server-side.
   *
   * @generated from rpc health.v1.HealthService.GetHealthTimeline
   */
  getHealthTimeline: {
    methodKind: "unary";
    input: typeof GetHealthTimelineRequestSchema;
    output: typeof GetHealthTimelineResponseSchema;
  },
  /**
   * GetServiceHealthStatus returns the latest health status for each service
   * check assigned to a workspace. Proxies to sunstone-status per-tenant status API.
   *
   * @generated from rpc health.v1.HealthService.GetServiceHealthStatus
   */
  getServiceHealthStatus: {
    methodKind: "unary";
    input: typeof GetServiceHealthStatusRequestSchema;
    output: typeof GetServiceHealthStatusResponseSchema;
  },
  /**
   * InvestigateService runs a live diagnostic against a workload via the
   * sunstone-investigate-controller and returns its root-cause finding.
   *
   * @generated from rpc health.v1.HealthService.InvestigateService
   */
  investigateService: {
    methodKind: "unary";
    input: typeof InvestigateServiceRequestSchema;
    output: typeof InvestigateServiceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_health_v1_health, 0);

